import { BadgeM } from "@common/components/badge/BadgeM"
import { theme } from "@common/theme/theme"
import { daysOptions } from "@data/constants/formConstants"
import React from "react"
import { View } from "react-native"

export function AvailabilitySlotsM({ slots, inline = false }) {
    const normalizedSlots = Array.isArray(slots)
        ? slots
        : typeof slots === "string"
        ? slots
              .split(",")
              .map((s) => s?.trim())
              .filter(Boolean)
        : slots && typeof slots === "object"
        ? Object.values(slots)
              .flatMap((v) => (Array.isArray(v) ? v : [v]))
              .filter(Boolean)
        : []

    return (
        <View
            style={{
                flexDirection: inline ? "row" : "column",
                alignItems: inline ? "center" : "flex-start",
                flexWrap: inline ? "wrap" : "nowrap",
            }}
        >
            {normalizedSlots?.map((slot, key) => {
                const raw =
                    slot && typeof slot === "object"
                        ? typeof slot?.day_time === "string"
                            ? slot.day_time
                            : [slot?.day, slot?.time || slot?.hour]
                                  .filter(Boolean)
                                  .join(" ")
                        : String(slot ?? "")

                const parts = raw.split(" ")
                const day = parts[0]
                const hour = parts[1]
                if (!day || !hour) return null
                const dayFr = daysOptions?.find((d) => d.value === day)?.label
                return (
                    <BadgeM
                        key={key}
                        style={{
                            backgroundColor: theme.colors.lighter,
                            color: theme.colors.grey,
                            marginVertical: 3,
                            marginRight: 3,
                        }}
                        count={" " + dayFr + " " + hour + " "}
                        size={23}
                    />
                )
            })}
        </View>
    )
}
